import React from 'react';
import { Link } from "react-router-dom";
import { getNavigationItems } from './navigationItems';

const MainNavigation = ({ props, active_link }) => {
  const navItems = getNavigationItems(props.isPro);

  return (
    <div className="desktop_navigation desktop-only">
      <ul className="navbar-nav navbar-nav__main-nav">
        {navItems.map((item) => (
          <li
            key={item.path}
            className={active_link === item.path ? "nav-item active" : "nav-item"}
          >
            {item.external ? (
              <a
                className={`nav-link ${item.className || ''}`}
                href={item.path}
                target={item.target}
                rel={item.rel}
                title={item.title}
              >
                {item.label} {item.external && <i className="fa fa-external-link-alt"></i>}
              </a>
            ) : (
              <Link
                className={
                  active_link === item.path 
                    ? `nav-link fw-bold ${item.className || ''}` 
                    : `nav-link ${item.className || ''}`
                }
                to={item.path}
                title={item.title}
                target="_parent"
              >
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MainNavigation; 